import lodash from 'lodash'
import Base from '../base.store'
import moment from "moment";
import { filter } from "../../../../utils/search";
import { cacheTime } from "../../../../utils/constant";

const baseUrl = '/api/v1/master/attachments'
const base = new Base(baseUrl)

export default {
    namespaced: true,
    state: lodash.merge(lodash.cloneDeep(base.state), {
        listModel: {},
        cacheDate: {
            listModel: {},
        },
    }),
    getters: {
        ...base.getters
    },
    actions: {
        ...base.actions,
        cacheFindAllByModel(context, { group, model, where = [], options }) {
            let force = options?.force ? options.force : false;
            const cacheDateResult = context.state.cacheDate.listModel[model];
            if (cacheDateResult && cacheDateResult.isBefore(moment())) {
                force = true;
            }
            if (group) {
                where.push({ name: "group", operator: "like", value: group });
            }
            const sort = [{ name: "createDate", type: "asc" }];
            const list = context.state.listModel[model] || [];
            if (list.length > 0 && !force) {
                return filter({ list, where, sort });
            }
            return context.dispatch("findAllByModel", { model }).then((list) => filter({ list, where, sort }));
        },
        findAllByModel(context, { criteria, config, model }) {
            criteria = lodash.merge(
                {
                    select: ["**"],
                    page: 0,
                    size: 1000000,
                    sort: [{ name: "createDate", type: "ASC" }],
                    where: [
                        { name: "isActive", type: "Boolean", operator: "=", value: true },
                        { name: "model", type: "String", operator: "=", value: model },
                    ],
                },
                criteria
            );
            return context.dispatch("search", { criteria, config }).then((page) => {
                const list = page.data;
                context.commit("setListModelResult", { model, list });
                return list;
            });
        },
    },
    mutations: {
        ...base.mutations,
        setListModelResult(state, { model, list }) {
            state.listModel[model] = list;
            state.cacheDate.listModel[model] = moment().add(cacheTime, "ms");
        },
    },
}
